/**
 * Expediente digital: categorías de documentos, tipos de archivo permitidos
 * y datos extraídos del DPI por OCR.
 */
import { z } from 'zod';
import { GENDERS } from './client.js';
/** Categorías de documento del expediente. */
export const DOCUMENT_CATEGORIES = [
    'dpi_front',
    'dpi_back',
    'proof_of_address',
    'income_proof',
    'business_photo',
    'home_photo',
    'collateral_photo',
    'collateral_title',
    'guarantor_dpi',
    'signed_contract',
    'signed_promissory_note',
    'disbursement_receipt',
    'other',
];
/** Etiquetas en español de cada categoría. */
export const DOCUMENT_CATEGORY_LABELS = {
    dpi_front: 'DPI (frente)',
    dpi_back: 'DPI (reverso)',
    proof_of_address: 'Recibo de luz / agua',
    income_proof: 'Constancia de ingresos',
    business_photo: 'Fotografía del negocio',
    home_photo: 'Fotografía de la vivienda',
    collateral_photo: 'Fotografía de la garantía',
    collateral_title: 'Escritura / tarjeta de circulación',
    guarantor_dpi: 'DPI del fiador',
    signed_contract: 'Contrato firmado',
    signed_promissory_note: 'Pagaré firmado',
    disbursement_receipt: 'Constancia de desembolso',
    other: 'Otro',
};
/** Categorías que cumplen el requisito de identidad de una solicitud. */
export const IDENTITY_DOCUMENT_CATEGORIES = ['dpi_front'];
/** Tipos MIME aceptados al cargar documentos (imágenes y PDF). */
export const ALLOWED_DOCUMENT_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
/** Bytes en un mebibyte. */
const BYTES_PER_MEBIBYTE = 1024 * 1024;
/** Tamaño máximo de un documento: 10 MiB (suficiente para una foto de teléfono o un PDF escaneado). */
export const MAX_DOCUMENT_BYTES = 10 * BYTES_PER_MEBIBYTE;
/** Datos que el OCR extrae del DPI; todos opcionales porque la lectura puede fallar. */
export const DpiOcrDataSchema = z.object({
    firstNames: z.string().nullable().optional(),
    lastNames: z.string().nullable().optional(),
    cui: z.string().nullable().optional(),
    birthDate: z.string().nullable().optional(),
    gender: z.enum(GENDERS).nullable().optional(),
    address: z.string().nullable().optional(),
});
//# sourceMappingURL=document.js.map